import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'ReadingStreakIcon16464',
  props: {
    active: { type: Boolean, default: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(["reading-streak-icon16464", { 'reading-streak-icon16464--active': __props.active }]),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13.575 3.623a.499.499 0 0 1 .838.062l4.988 9.186a.5.5 0 0 0 .822.084l3.949-4.67a.488.488 0 0 1 .651-.09c.735.508 2.4 1.71 3.328 2.777 2.421 2.784 3.349 5.499 3.349 8.708v.418C31.5 27.218 25.465 33 18.017 33l-.034-.003C10.535 32.98 4.5 27.214 4.5 20.077v-.001c0-3.21 1.174-5.751 3.347-8.725 1.923-2.63 4.648-6.283 5.728-7.728Z" }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "streak-icon-active-gradient",
        x1: "4.5",
        y1: "18",
        x2: "31.5",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", { "stop-color": "#FF7124" }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#D04A00"
        })
      ])
    ], -1)
  ]))], 2))
}
}

})